import axios from 'axios';
import { logoutUser, getUser, isLoggedOut } from '../actions/session';
import { Notifications } from '../components/common/notification';

// Create axios instance with default config
const axiosInstance = axios.create();

// Request interceptor - adds auth header to all requests
axiosInstance.interceptors.request.use(
    (config) => {
        const user = getUser();
        if (user && user.token) {
            config.headers['Authorization'] = `Bearer ${user.token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor - handles 401 errors globally
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Check if error response exists and is a 401 or has expired JWT message
        if (error.response) {
            const status = error.response.status;
            const message = error.response.data?.message || '';

            // Check for 401 status or expired JWT message
            if (status === 401 || message === 'invalid or expired jwt') {
                // Only logout if not already logged out
                if (!isLoggedOut()) {
                    const didLogout = logoutUser();

                    if (didLogout) {
                        // Show notification only once
                        Notifications.notify(
                            'Your session has expired. Please login again.',
                            'Session Expired',
                            'warning'
                        );

                        // Redirect to login page
                        // Using window.location for a clean redirect that works regardless of router context
                        window.location.href = '/login';
                    }
                }
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
